import { duration, Input, TextareaAutosize, Typography } from "@mui/material";
import React, { useEffect } from "react";

const PixverseImageToVideoSettings = ({
  onSettingsChange,
  selectedPrompt,
  generateExact,
}) => {
  const [settings, setSettings] = React.useState({
    duration: "2",
    prompt: selectedPrompt?.prompt || "",
    negativePrompt: "",
    aspectRatio: "16:9",
    resolution: "540p",
    seed: generateExact ? selectedPrompt?.seed : "",
  });
  useEffect(() => {
    // Update settings when selectedPrompt changes
    if (selectedPrompt?.prompt) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        prompt: selectedPrompt?.prompt,
      }));
    }else{
      setSettings((prevSettings) => ({
        ...prevSettings,
        prompt: "",
      }));
    }
  }, [selectedPrompt?.prompt]);
  useEffect(() => {
    // Update settings when selectedPrompt changes
    if (selectedPrompt?.prompt) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        seed: generateExact ? selectedPrompt?.seed : "",
      }));
    }
  }, [selectedPrompt?.seed, generateExact]);
  useEffect(() => {
    // Call onSettingsChange when component mounts to set initial settings
    onSettingsChange?.(settings);
  }, [settings]);
  const handleSettingChange = (key, value) => {
    if (key === duration) {
      // Ensure duration is a number
      value = Number(value);
      if (isNaN(value) || value < 2 || value > 5) {
        console.error(
          "Invalid duration value. Must be between 2 and 5 seconds."
        );
        return;
      }
    }
    const newSettings = { ...settings, [key]: value };
    setSettings(newSettings);
    onSettingsChange?.(newSettings);
    console.log("Pixverse Effects settings updated:", newSettings);
  };
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Typography className="text-gray-300">Video Duration</Typography>
          <select
            value={settings.duration}
            onChange={(e) => handleSettingChange("duration", e.target.value)}
            className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          >
            <option value="2">2 seconds</option>
            <option value="3">3 seconds</option>
            <option value="4">4 seconds</option>
            <option value="5">5 seconds</option>
          </select>
          <p className="text-xs text-gray-400 mt-1">
            Duration of the generated video
          </p>
        </div>
        <div>
          <Typography className="text-gray-300">Aspect Ratio</Typography>
          <select
            value={settings.aspectRatio}
            onChange={(e) => handleSettingChange("aspectRatio", e.target.value)}
            className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          >
            <option value="16:9">16:9 (Widescreen)</option>
            <option value="9:16">9:16 (Portrait)</option>
            <option value="1:1">1:1 (Square)</option>
            <option value="4:3">4:3 (Classic)</option>
          </select>
          <p className="text-xs text-gray-400 mt-1">
            Output video aspect ratio
          </p>
        </div>
        {/* <div>
          <Typography className="text-gray-300">Motion Strength</Typography>
          <Input
            type="range"
            min="0.1"
            max="1.0"
            step="0.1"
            defaultValue="0.7"
            className="w-full bg-gray-700 border-gray-600 text-white"
          />
          <p className="text-xs text-gray-400 mt-1">
            Controls the intensity of motion
          </p>
        </div> */}
      </div>
      <div>
        <Typography className="text-gray-300">Resolution</Typography>
        <select
          placeholder="Choose resolution"
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          value={settings.resolution}
          onChange={(e) => handleSettingChange("resolution", e.target.value)}
        >
          <option value="360p">360p</option>
          <option value="540p">540p</option>
          <option value="720p">720p</option>
          <option value="1080p">1080p (Full HD)</option>
        </select>
        <p className="text-xs text-gray-400 mt-1">
          Higher resolutions support more effects but take longer to process
        </p>
      </div>
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Typography className="text-gray-300">Quality</Typography>
          <select className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white">
            <option value="standard">Standard</option>
            <option value="high">High</option>
            <option value="ultra">Ultra</option>
          </select>
          <p className="text-xs text-gray-400 mt-1">Video quality level</p>
        </div>
      </div> */}

      <div>
        <Typography className="text-gray-300">Prompt</Typography>
        <TextareaAutosize
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white resize-none"
          rows={3}
          placeholder="Describe the motion you want to see in the video..."
          onChange={(e) => handleSettingChange("prompt", e.target.value)}
          value={settings.prompt}
        />
        <p className="text-xs text-gray-400 mt-1">
          Describe the motion you want to see in the video
        </p>
      </div>

      <div>
        <Typography className="text-gray-300">Negative Prompt</Typography>
        <TextareaAutosize
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white resize-none"
          rows={2}
          placeholder="What you don't want in the result..."
          onChange={(e) =>
            handleSettingChange("negativePrompt", e.target.value)
          }
          value={settings.negativePrompt}
        />
        <p className="text-xs text-gray-400 mt-1">
          Describe what should be avoided
        </p>
      </div>
    </div>
  );
};
export default PixverseImageToVideoSettings;
